var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiagonalArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 28,
  height: 20,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#121313",
  d: "M27.718 4.291a.99.99 0 0 0-1.404 0L6 24.604v-7.596a1 1 0 0 0-2 0v10c0 .265.103.521.291.709s.444.291.709.291h10a1 1 0 0 0 0-2H7.404L27.718 5.695a.99.99 0 0 0 0-1.404"
})));
export default SvgDiagonalArrow;